"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agendaSlotReservationApiSchema = exports.slotReservationDoctorSubstituteSchema = exports.reservationStatus = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const profile_schema_1 = require("../global/profile.schema");
exports.reservationStatus = ['pending', 'confirmed'];
exports.slotReservationDoctorSubstituteSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('doctor-substitutes'),
    attributes: zod_1.z.object({
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        picture: profile_schema_1.pictureSchema,
        phoneNumber: zod_1.z.string().optional(),
        email: zod_1.z.string().optional(),
        rhythm: zod_1.z.string().optional(),
        onSiteSlotsWithoutAssistant: zod_1.z.number().nullable().optional(),
        remoteSlotsWithoutAssistant: zod_1.z.number().nullable().optional(),
        onSiteSlotsWithAssistant: zod_1.z.number().nullable().optional(),
        remoteSlotsWithAssistant: zod_1.z.number().nullable().optional(),
        rhythmNote: zod_1.z.string().nullable().optional(),
        priority: zod_1.z.number().nullable().optional(),
        installable: zod_1.z.boolean(),
        hasPhysicalSiteAccess: zod_1.z.boolean(),
    }),
});
exports.agendaSlotReservationApiSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('agenda-slot-reservations'),
    attributes: zod_1.z.object({
        status: zod_1.z.enum(exports.reservationStatus),
        tag: zod_1.z.string().optional(),
    }),
    relationships: zod_1.z
        .object({
        doctorSubstitute: (0, api_1.apiEntityRelationshipSchema)('doctor-substitutes').optional(),
    })
        .optional()
        .default({}),
});
